



























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UniformDto from '@/models/Uniforms/UniformDto';
import UpdateUniformRequest from '@/models/Uniforms/UpdateUniformRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'UniformEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new UniformDto

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentUniform));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateUniformRequest()
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    request.description = this.entity.description;
    await AgencySettingsModule.editUniform(request)
    this.dialog = false;
  }
}
